"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchSearchResultItem = void 0;
const react_1 = __importStar(require("react"));
const ClickableItemCard_1 = require("@Components/ClickableItemCard");
const clsx_1 = __importDefault(require("clsx"));
const react_router_dom_1 = require("react-router-dom");
const match_search_result_item_header_1 = require("@Components/MatchComponents/v2/MatchSearchResultItem/match-search-result-item-header");
const Status_1 = __importDefault(require("@Components/Status"));
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
require("./index.scss");
const dayjs_1 = __importDefault(require("dayjs"));
const MatchSearchResultItem = (props) => {
    const { rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const path = navigation_1.default.rightholder.matchClaim.matchUsage(rightsholderStore.currentRightsholderId, props.suggestedMatchId);
    const recordingGroupCount = props.recordingGroupsSubmitted +
        props.recordingGroupsApproved +
        props.recordingGroupsRejected +
        props.recordingGroupsSuperseded;
    return (react_1.default.createElement(ClickableItemCard_1.ClickableItemCard, { className: (0, clsx_1.default)('suggested-match-item'), handleOnClick: () => { }, path: path },
        react_1.default.createElement("div", { className: 'small-portal-column submission-date' }, (0, dayjs_1.default)(props.submissionTimestamp, 'YYYY-MM-DD HH:mm:ss ZZ')
            .toDate()
            .toLocaleString('default', { month: 'short', day: 'numeric', year: 'numeric' })),
        react_1.default.createElement("div", { className: 'small-portal-column  recording-groups-count' }, recordingGroupCount),
        react_1.default.createElement("div", { className: 'small-portal-column work-title' },
            react_1.default.createElement(react_router_dom_1.Link, { to: path, className: 'title-link', onClick: (e) => {
                    e.stopPropagation();
                }, onMouseDown: (e) => {
                    e.stopPropagation();
                } }, props.workTitle)),
        react_1.default.createElement("div", { className: 'small-portal-column song-code' }, props.currentSongCode),
        react_1.default.createElement("div", { className: 'writers' }, props.workWriters && props.workWriters.split('|').join(', ')),
        react_1.default.createElement(Status_1.default, { status: props.submissionStatus })));
};
exports.MatchSearchResultItem = MatchSearchResultItem;
exports.MatchSearchResultItem.headerType = match_search_result_item_header_1.MatchSearchResultItemHeader;
exports.default = exports.MatchSearchResultItem;
